// extracted by mini-css-extract-plugin
module.exports = {"storeBadges":"AppBadges_storeBadges__34OT8"};